import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { TransactionsSection, TransactionDetailDrawer, financeLoader, type Transaction } from '@spcc/domains/finance'

export const Route = createFileRoute('/finance/transactions')({
  loader: financeLoader,
  component: TransactionsPage,
})

function TransactionsPage() {
  const [selectedTransaction, setSelectedTransaction] = useState<Transaction | null>(null)
  const [drawerOpen, setDrawerOpen] = useState(false)

  const handleSelectTransaction = (transaction: Transaction) => {
    setSelectedTransaction(transaction)
    setDrawerOpen(true)
  }

  return (
    <>
      <TransactionsSection onSelectTransaction={handleSelectTransaction} />
      <TransactionDetailDrawer
        transaction={selectedTransaction}
        open={drawerOpen}
        onOpenChange={setDrawerOpen}
      />
    </>
  )
}
